import React from 'react';
import { Helmet } from 'react-helmet-async';
export default function SEO({ title, description, name, image }) {
    return (
        <Helmet>
            { /* Standard metadata tags */}
            <title>{title}</title>
            <meta name='description' content={description} />
            { /* End standard metadata tags */}
            { /* Facebook tags */}
            { /*<meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            {image && <meta property="og:image" content={image} />}
    {!image && <meta property="og:image" content="/fstor/logo/medium-logo.jpg" />} */}
            { /* End Facebook tags */}
            { /* Twitter tags */}
           { /* <meta name="twitter:creator" content={name} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {image && <meta property="twitter:image" content={image} />}
{!image && <meta property="twitter:image" content="/fstor/logo/medium-logo.jpg" />} */ }

            { /* End Twitter tags */}
        </Helmet>
    )
}